(function () {
    'use strict';

    angular
        .module('reports')
        .controller('ScoresReportCtrl', ScoresReportCtrl);

    ScoresReportCtrl.$inject = ['$scope', '$routeParams', 'reportsService', app.modules.common.services.functions, app.modules.scoring.services.gamescore, app.modules.ui.services.alerts];
    function ScoresReportCtrl($scope, $routeParams, service, ggFunctions, ggScoringSvc, ggAlertSvc) {
        // Interface
        var vm = this, groupId = $routeParams.groupId;
        vm.data = null;
        vm.flaggedCount = 0;
        vm.toggleScore = toggleScore;
        vm.state = 'ready';
        vm.runReport = runReport;
        vm.toggle = toggle;
        vm.postSelectedScores = postSelectedScores;

        vm.startDate = new Date().addDays(-30);
        vm.endDate = new Date();
        vm.reportType = 'all';

        vm.dateOptions = { minDate: new Date(2016, 1, 1), maxDate: new Date() };
        vm.reportTypeOptions = { all: 'All', group: 'Groups Only', nonGroup: 'Non Group' };

        // Implementation
        function complete() {
            ggFunctions.toggleProcessing(false);
        }

        function error(response) {
            vm.state = 'error';
        }

        function runReport() {
            if ($scope.form.$valid) {
                vm.data = null;
                vm.state = 'loading';
                ggFunctions.toggleProcessing(true);

                service
                    .fetchScoresReport(groupId, vm.startDate, vm.endDate, vm.reportType)
                    .then(success)
                    .catch(error)
                    .finally(complete);
            }
            else
                $scope.form.$setTouched(); // <== Show all error messages
        }

        function success(response) {
            vm.state = 'loaded';
            vm.data = response.data;
        }

        function toggle(player) {
            player.expanded = !player.expanded;
        }

        function toggleScore(score) {
            if (score.state == 'not-posted') {
                score.flagged = !score.flagged;
                vm.flaggedCount = vm.flaggedCount + (score.flagged ? 1 : -1);
            }
        }

        function postSelectedScores() {
            var
                scores,
                scoreIdList,
                players = vm.data.players,
                dialog = new ggAlertSvc.popup(),
                postScoresToHandicap = ggScoringSvc.score.postScoresToHandicap.bind(ggScoringSvc.score);

            // Get Selected Scores
            scores = players.selectMany(selectMany).filter(filter);
            scoreIdList = scores.map(map);

            // Call Api
            ggFunctions.toggleProcessing(true);
            postScoresToHandicap(scoreIdList).then(success).catch(error).finally(complete);

            function selectMany(player) { return player.scores; }
            function filter(score) { return score.flagged; }
            function map(score) { return score.id; }

            function success() {
                scores.forEach(function (score) {
                    score.flagged = false;
                    score.isPosted = true;
                });
                vm.flaggedCount = 0;
                dialog.success('Scores posted', 'Scores were successfully posted to handicap.');
            }
            function error() {
                dialog.fail("Error", 'Unable to post scores to handicap.');
            }
            function complete() {
                ggFunctions.toggleProcessing(false);
            }
        }
    }
})();